import { useQuery } from '@tanstack/react-query';

import { rpcClient } from '../lib/orpc.js';
import { queryKeys } from '../lib/query-keys.js';

/**
 * 案件の一覧（開発タブ）を取る。スプシは人や自動の書き手が数時間で書き換えるので、
 * 画面に戻ったときに古い並びを使い回さず読み直し、［最新を読み込む］は refetch で読み直す。
 *
 * @graph-node {Function}
 * @graph-stack ac-mens-hub
 * @graph-domain Operations
 * @graph-business メンズの案件一覧（全社スプシの開発タブの区分・並び・ずれ・Backlog の値）を取得する React Query フック
 * @graph-connects rpcClient [calls] oRPC productBacklog.list 呼び出し
 */
export function useProductBacklog() {
  return useQuery({
    queryKey: queryKeys.productBacklog.list,
    queryFn: () => rpcClient.productBacklog.list(),
    staleTime: 0,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
